
import { SeparatorHorizontal } from "lucide-react";
import { Separator } from "@shared/components/ui/separator";

export const ExperienceSeparator = () => (
  <div className="w-full max-w-xs flex items-center justify-center">
    <SeparatorHorizontal
      size={24}
      className="text-foreground/40 w-full"
      strokeWidth={1}
    />
  </div>
);
